import { render } from "./EducationCategory.vue?vue&type=template&id=68e985d6&scoped=true"
import script from "./EducationCategory.vue?vue&type=script&lang=js"
export * from "./EducationCategory.vue?vue&type=script&lang=js"

import "./EducationCategory.vue?vue&type=style&index=0&id=68e985d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e985d6"]])

export default __exports__